import React, { useEffect, useState, useRef } from 'react'
import { AiOutlineMessage, AiOutlinePlus } from 'react-icons/ai'
import { IoSend } from 'react-icons/io5'
import { Link, useParams, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { add_friend, send_message, updateMessage, messageClear } from '../../store/reducers/chatReducer'
import toast from 'react-hot-toast'

const Chat = () => {

    const scrollRef = useRef()

    const dispatch = useDispatch()
    const { sellerId } = useParams()
    const [text, setText] = useState('')
    const [receverMessage, setReceverMessage] = useState('')
    const [activeSeller, setActiveSeller] = useState([])
    const { userInfo } = useSelector(state => state.auth)
    const location = useLocation();
    const { fd_messages, currentFd, my_friends, successMessage } = useSelector(state => state.chat)

    const isLinkActive = (path) => {
        return location.pathname.includes(path);
    };

    useEffect(() => {
        dispatch(add_friend({
            sellerId: sellerId || "",
            userId: userInfo.id
        }))
    }, [sellerId])

    const send = () => {
        if (text) {
            dispatch(send_message({
                userId: userInfo.id,
                text,
                sellerId,
                name: userInfo.name
            }))
            setText('')
        }
    }
    
    // Socket receiver removed

    useEffect(() => {
        if (successMessage) {
            // Socket emission removed
            dispatch(messageClear())
        }
    }, [successMessage])

    useEffect(() => {
        console.log(receverMessage)
        if (receverMessage) {
            if (sellerId === receverMessage.senderId && userInfo.id === receverMessage.receverId) {
                dispatch(updateMessage(receverMessage))
            } else {
                toast.success(receverMessage.senderName + " " + "send a message")
                dispatch(messageClear())
            }
        }
    }, [receverMessage])

    useEffect(() => {
        scrollRef.current?.scrollIntoView({ behavior: 'smooth' })
    }, [fd_messages])

    return (
        <div className='bg-white sm:bg-whitesmoke p-3 rounded-md '>
            <div className='w-full  flex sm:flex-col'>
                <div className='w-[230px] sm:w-full'>
                    <div className='flex justify-center gap-2 items-center text-slate-600 text-xl h-[50px]'>
                        <span><AiOutlineMessage /></span>
                        <span className=''>Message</span>
                    </div>
                    <div className='w-full  flex flex-col text-slate-600 py-4 h-[400px] sm:h-auto pr-3'>
                        {
                            my_friends.map((f, i) => (
                                <Link to={`/dashboard/chat/${f.fdId}`} key={i} className={`flex sm:border-2 md:justify-start gap-3 w-full drop-shadow-md justify-start rounded-full items-center pl-2 m-2 py-2 ${isLinkActive(`/dashboard/chat/${f.fdId}`) ? 'bg-[#1e2951] text-white border-0' : ''}`} >
                                <div className='w-[30px] h-[30px] rounded-full  relative'>
                                    {
                                        activeSeller.some(c => c.sellerId === f.fdId) && <div className='w-[10px] h-[10px] rounded-full bg-green-500 absolute right-0 bottom-0'></div>
                                    }
                                    <img className='rounded-full ' src={`/images/admin.png`} alt="" />
                                </div>
                                <span className='text-semibold'>{f.name}</span>
                            </Link>
                            
                            ))
                        }
                    </div>
                </div>
                <div className='w-[calc(100%-230px)] md:w-[100%] md:mb-[15%]'>
                    {
                        currentFd ? <div className='w-full h-full'>
                            <div className='flex justify-start gap-3 items-center text-slate-600 text-xl h-[50px]'>
                                <div className='w-[30px] h-[30px] rounded-full relative'>
                                    {
                                        activeSeller.some(c => c.sellerId === currentFd.fdId) && <div className='w-[10px] h-[10px] rounded-full bg-green-500 absolute right-0 bottom-0'></div>
                                    }
                                    <img src={`/images/admin.png`} alt="" />
                                </div>
                                <span>{currentFd.name}</span>
                            </div>
                            <div className='h-[400px] w-full bg-slate-100 p-3  rounded-md'>
                                <div className='w-full h-full overflow-y-auto flex flex-col gap-3'>
                                    {
                                        fd_messages.map((m, i) => {
                                            if (currentFd?.fdId !== m.receverId) {
                                                return (
                                                    <div key={i} className='w-full rounded-full flex gap-2 justify-start items-center text-[14px]'>
                                                        <img className='w-[30px] rounded-full h-[30px] ' src={`/images/admin.png`} alt="" />
                                                        <div className='p-2 bg-pink-600 text-white  rounded-r-xl rounded-t-xl'>
                                                            <span>{m.message}</span>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    <div key={i} className='w-full rounded-full flex gap-2 justify-end items-center text-[14px]'>
                                                        
                                                        <div className='p-2 bg-cyan-500 text-white rounded-l-xl rounded-t-xl'>
                                                            
                                                            <span>{m.message}</span>
                                                        </div>
                                                        <img className='w-[30px] rounded-full h-[30px] ' src={`/images/user.png`} alt="" />
                                                    </div>
                                                )
                                            }
                                        })
                                    }

                                </div>
                            </div>
                            <div className='flex p-2 justify-center items-center w-full'>
                                
                                <div className='border h-[40px] p-0 ml-2 w-[calc(100%-10px)] rounded-full relative'>
                                    <input value={text} onChange={(e) => setText(e.target.value)} type="text" placeholder='input message' className='w-full rounded-full h-full outline-none p-3' />
                                    

                                </div>
                                <div className='w-[40px] p-2 justify-center items-center rounded-full '>
                                    <div onClick={send} className='text-2xl text-teal-500 cursor-pointer'>
                                        <IoSend />
                                    </div>
                                </div>
                            </div>
                        </div> : 
                        
                        <div className='w-full h-full flex flex-col justify-center items-center text-lg text-slate-400'>
                            <img className='w-[50%] h-[40%]' src={`/images/chat.svg`} alt="" />
                            <span className='text-center'>Select Seller</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Chat